export default __webpack_public_path__ + "static/media/ta.17c87776.jpg";